import { ModalId } from '@heidi/schema/ml-scribe';

/**
 * Precharting beta (Athena / Google ADK agents) onboarding modal IDs.
 *
 * Both ids are backend `ModalId` enum members (the ml-scribe PR landed and the
 * schema was regenerated), so the former `as ModalId` casts are gone. The id
 * STRINGS are unchanged and must stay that way: they key the backend-synced
 * `seenModalIds` set and `ModalView` dismiss records, so renaming one
 * resurfaces the modal for every user who has already seen it (the frozen-id
 * law — OpenSpec `monorepo-shell-registry` design D4).
 */
export const PRECHART_BETA_INTRO_MODAL_ID = ModalId.PRECHART_BETA_INTRO_MODAL;
export const PRECHART_BETA_TAB_SPOTLIGHT_ID = ModalId.PRECHART_BETA_TAB_SPOTLIGHT;
